import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Header, Button, Image } from 'semantic-ui-react';


class ImageCard extends Component {

    render() {        
        return (
            <div style={{marginTop: "2em", marginBottom: "2em"}}>
                {this.props.item.title && <Header as='h2'>{this.props.item.title}</Header>}
                <Link to={this.props.item.linkToPage ? "/page/"+this.props.item.linkToPage : "/play/"+this.props.item.story}>
                    <Image
                        rounded
                        centered
                        size="big"
                        style={{cursor: 'pointer'}}
                        src={this.props.item.img} />
                </Link>
            </div>
        );
    }
}

const truncate = (str, n) => {
    return (str.length > n) ? str.substr(0, n-1) + '...' : str;
};

export default ImageCard;



// WEBPACK FOOTER //
// ./src/components/PageComponents/ImageCard.js